/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type WebAppOnboardingComplete_org = {
    readonly slackSettingsErrorable: {
        readonly list?: ReadonlyArray<{
            readonly id: string;
            readonly slackTeamId: string;
        }> | undefined;
    };
    readonly " $refType": "WebAppOnboardingComplete_org";
};
export type WebAppOnboardingComplete_org$data = WebAppOnboardingComplete_org;
export type WebAppOnboardingComplete_org$key = {
    readonly " $data"?: WebAppOnboardingComplete_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"WebAppOnboardingComplete_org">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "WebAppOnboardingComplete_org",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "slackSettingsErrorable",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "SlackSettings",
                            "kind": "LinkedField",
                            "name": "list",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "slackTeamId",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "type": "SlackSettingsList",
                    "abstractKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Org",
    "abstractKey": null
} as any;
(node as any).hash = 'ebe53bf1640861c08005631c7f5f44da';
export default node;
